@if (loader) {
  <ng-casto-loader></ng-casto-loader>
} @else {
  <div>
    <div class="button-container">
      <a class="add-button" (click)="addQuotation()" [ngClass]="{ disabled: isSupplierSent() }">
        {{ 'popins.products_list.main.buttons.add-product' | translate }}
      </a>

      <a class="add-button" (click)="addAssistance()" [ngClass]="{ disabled: isSupplierSent() }">
        {{ 'popins.products_list.main.buttons.add-assistance' | translate }}
      </a>

      @if (order != undefined) {
        <a
          class="add-button"
          [ngClass]="{ disabled: isOrderNumberEditionDisabled() }"
          (click)="orderNumberEdition()">
          {{ 'popins.products_list.main.buttons.edit-order-number' | translate }}
        </a>
      }
    </div>

    <!-- Order numbers -->
    @if (order != null) {
      <p class="order-numbers">
        {{ 'popins.products_list.order.dotcom-ordered' | translate }}
        {{ order.sendDate | date: 'dd/MM/y' }}
        <small class="opportunity-number">
          ({{ 'popins.products_list.order.opportunity-number' | translate }} {{ order.opportunityNumber }})
        </small>
      </p>
    }

    @if (isOrderNumberEditionDisabled()) {
      <p class="order-modified">
        {{ 'popins.products_list.order.order-modified' | translate }}
      </p>
    }

    <!-- Discount expired-->
    @if (discountExpired) {
      <p class="discount-expired">
        {{ 'popins.products_list.aside.discount-expired' | translate }}
        {{ order.quotationExpirationDate | date: 'dd/MM/y' }}.
        {{ 'popins.products_list.aside.order-recommendation' | translate }}
      </p>
    }

    <div class="content-body">
      <!-- Pas de produits -->
      @if (this.shoppingCartProductList.shoppingCartProductCategories.length == 0) {
        <div class="init-text pt-5">
          {{ 'popins.products_list.empty' | translate }}
        </div>
      }

      <!-- Categorie de produit -->
      @for (productCategory of this.shoppingCartProductList.shoppingCartProductCategories; track productCategory.name) {
        <section class="product-category">
          <!-- Titre de la catégorie -->
          <section class="product-category-title">
            <p>{{ productCategory.name }}</p>
            <p>
              @if (orderLoad[0] == productCategory.name) {
                <ng-casto-loader></ng-casto-loader>
              } @else {
                <span>
                  {{
                    (productCategory.totalPriceDiscountTtc
                      ? productCategory.totalPriceDiscountTtc
                      : productCategory.totalPriceTtc
                    ) | number: '1.2-2' : 'fr'
                  }}
                  €
                </span>
              }
            </p>
          </section>

          <!-- Liste des produits -->
          <table class="table product-table-cart">
            <thead>
              <tr>
                <!-- Thumbnail -->
                <th class="large-column"></th>

                <th>{{ 'popins.products_list.main.columns.ean' | translate }}</th>
                <th class="extra-large-column">{{ 'popins.products_list.main.columns.name' | translate }}</th>
                <th class="medium-column">{{ 'popins.products_list.main.columns.discount' | translate }}</th>
                <th class="small-column">{{ 'popins.products_list.main.columns.tva' | translate }}</th>
                <th class="medium-column">{{ 'popins.products_list.main.columns.unitPrice' | translate }}</th>
                <th>{{ 'popins.products_list.main.columns.qty' | translate }}</th>
                <th class="medium-column">{{ 'popins.products_list.main.columns.totalTtc' | translate }}</th>
                <th>{{ 'popins.products_list.main.columns.observations' | translate }}</th>
                <th class="large-column">{{ 'popins.products_list.main.columns.actions' | translate }}</th>
                <th>{{ 'popins.products_list.main.columns.supplier-sent' | translate }}</th>
              </tr>
            </thead>

            <tbody>
              @for (product of productCategory.shoppingCartProducts; track product.externalId) {
                <!-- Produits -->
                <tr>
                  <!-- Thumbnail -->
                  <td><img class="img-product" [src]="product.thumbnail" /></td>

                  <!-- Ean -->
                  <td>{{ product.ean }}</td>

                  <!-- Name -->
                  <td class="text-left">
                    <h6>{{ product.name }}</h6>
                    @if (product.options) {
                      <ul>
                        @for (option of getSortedOptions(product); track option.label) {
                          <li>{{ option.label }}</li>
                        }
                      </ul>
                    }
                  </td>

                  <!-- Discount -->
                  <td class="info">
                    <ng-select
                      class="discount-select"
                      [disabled]="isSupplierSent()"
                      [items]="product.availableDiscounts"
                      bindValue="ean"
                      bindLabel="discountValue"
                      [(ngModel)]="product.ean"
                      (change)="updateDiscount(product)"
                      [clearable]="false">
                      <ng-template ng-label-tmp let-item="item">
                        <span
                          [ngClass]="{
                            'expired-discount': isDiscountExpired(item),
                          }">
                          {{ item.discountValue }} %
                        </span>
                      </ng-template>

                      <ng-template ng-option-tmp let-item="item">
                        <p
                          [ngClass]="{
                            'expired-discount': isDiscountExpired(item),
                          }">
                          {{ item.discountValue }} %
                        </p>
                        @if (isDiscountExpired(item)) {
                          <small class="expired-discount">
                            {{ 'popins.products_list.main.discount-expired' | translate }}
                          </small>
                        }
                      </ng-template>
                    </ng-select>
                  </td>

                  <!-- TVA -->
                  <td>
                    @if (orderLoad[1] == product.externalId) {
                      <ng-casto-loader></ng-casto-loader>
                    } @else {
                      <div>
                        {{ product.tva }}%
                        @if (!isSupplierSent()) {
                          <svg class="icon-action-edit" (click)="updateTva(product)">
                            <use xlink:href="assets/img/icons.svg#icon-action-edit"></use>
                          </svg>
                        }
                      </div>
                    }
                  </td>

                  <!-- Unit price -->
                  <td class="text-right">
                    @if (orderLoad[1] == product.externalId) {
                      <ng-casto-loader></ng-casto-loader>
                    } @else {
                      <div>
                        @if (!product.discount) {
                          <p>{{ product.unitPriceTtc | number: '1.2-2' : 'fr' }}&nbsp;€</p>
                        }
                        @if (product.discount) {
                          <span>
                            <p>
                              <s>
                                <i>{{ product.unitPriceTtc | number: '1.2-2' : 'fr' }}&nbsp;€</i>
                              </s>
                            </p>

                            <p>{{ product.unitPriceDiscountTtc | number: '1.2-2' : 'fr' }}&nbsp;€</p>
                          </span>
                        }

                        @if (product.unitEcoTaxTtc > 0) {
                          <span class="ecofees">
                            <br />
                            {{ 'popins.products_list.aside.totalEcotax' | translate }}
                            {{ product.unitEcoTaxTtc | number: '1.2-2' : 'fr' }}&nbsp;€
                          </span>
                        }
                      </div>
                    }
                  </td>

                  <!-- Quantity -->
                  <td>
                    @if (orderLoad[1] == product.externalId) {
                      <ng-casto-loader></ng-casto-loader>
                    } @else {
                      <div>
                        {{ product.quantity }}
                        @if (!isSupplierSent()) {
                          <svg class="icon-action-edit" (click)="updateQuantity(product)">
                            <use xlink:href="assets/img/icons.svg#icon-action-edit"></use>
                          </svg>
                        }
                      </div>
                    }
                  </td>

                  <!-- TTC -->
                  <td class="text-right">
                    @if (orderLoad[1] == product.externalId) {
                      <ng-casto-loader></ng-casto-loader>
                    } @else {
                      <div>
                        @if (!product.discount) {
                          <p>{{ product.totalPriceTtc | number: '1.2-2' : 'fr' }}&nbsp;€</p>
                        }
                        @if (product.discount) {
                          <span>
                            <p>
                              <s>
                                <i>{{ product.totalPriceTtc | number: '1.2-2' : 'fr' }}&nbsp;€</i>
                              </s>
                            </p>

                            <p>{{ product.totalPriceDiscountTtc | number: '1.2-2' : 'fr' }}&nbsp;€</p>
                          </span>
                        }

                        @if (product.totalEcoTaxTtc > 0) {
                          <span class="ecofees">
                            <br />
                            {{ 'popins.products_list.aside.totalEcotax' | translate }}
                            {{ product.totalEcoTaxTtc | number: '1.2-2' : 'fr' }}&nbsp;€
                          </span>
                        }
                      </div>
                    }
                  </td>

                  <!-- Observations -->
                  <td>
                    @if (product.observation != undefined) {
                      <button class="icon-observation">
                        <fa-icon [icon]="faCommentAlt" (click)="displayObservations(product.observation)" size="lg"></fa-icon>
                      </button>
                    }
                  </td>

                  <!-- Actions -->
                  <td>
                    <div class="button-container center">
                      <a
                        class="add-button"
                        (click)="editQuote(product.externalId)"
                        [ngClass]="{ disabled: isSupplierSent() }">
                        {{ 'popins.products_list.main.buttons.edit' | translate }}
                      </a>

                      @if (!isSupplierSent()) {
                        <button (click)="deleteProduct(product.externalId, $event)" class="section-delete-button">
                          <svg>
                            <use
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                              xlink:href="assets/img/icons.svg#icon-action-delete"></use>
                          </svg>
                        </button>
                      }
                    </div>
                  </td>

                  <!-- Check supplier sent -->
                  <td>
                    @if (product.supplierSent) {
                      <fa-icon
                        class="supplier-sent-icons check"
                        [icon]="faCheck"
                        size="2x">
                      </fa-icon>
                      @if (product.supplierSentLastDate) {
                        <p class="supplier-sent-date">
                          {{ product.supplierSentLastDate | date: 'dd/MM/y' }}
                        </p>
                      }
                    }

                    @if (!product.supplierSent && order?.opportunityNumber) {
                      <p class="supplier-pending-order-number">
                        {{ 'popins.products_list.main.columns.supplier-pending-order-number' | translate }}
                      </p>
                    }

                    @if (!product.supplierSent && !order?.opportunityNumber && product.supplierSentLastDate) {
                      <fa-icon
                        class="supplier-sent-icons hourglass"
                        [icon]="faHourGlass"
                        size="2x">
                      </fa-icon>
                    }
                  </td>
                </tr>

                <!-- Accessories -->
                <tr [class.product-last]="product.accessories.length == 0">
                  <td colspan="12" class="product-accessories-title">
                    <div class="button-container">
                      <a
                        class="add-button shift"
                        (click)="addAccessory(product.externalId)"
                        [ngClass]="{ disabled: !product.accessoriesAvailable || isSupplierSent() }">
                        {{
                          product.accessoriesAvailable
                            ? ('popins.products_list.main.buttons.add-accessory' | translate)
                            : ('popins.products_list.main.buttons.no-accessories' | translate)
                        }}
                      </a>
                      <a
                        class="add-button shift"
                        (click)="duplicateProduct(product, productCategory)"
                        [ngClass]="{ disabled: isSupplierSent() }">
                        {{ 'popins.products_list.main.buttons.duplicate-product' | translate }}
                      </a>
                    </div>
                  </td>
                </tr>

                @if (product.accessories.length > 0) {
                  <tr>
                    <td colspan="12" class="product-accessories-title">
                      <h6>{{ 'popins.products_list.main.accessories' | translate: { name: product.name } }}</h6>
                    </td>
                  </tr>
                }

                @for (accessory of product.accessories; track accessory.accessory.id) {
                  <tr
                    [class.product-last]="$last"
                    class="product-accessory">
                    <!-- Thumbnail -->
                    <td>
                      <ng-casto-img-loader
                        [imgSrc]="baseImgUrl + accessory.accessory.thumbnail"
                        [imgClass]="'img-product'"></ng-casto-img-loader>
                    </td>

                    <!-- EAN -->
                    <td>{{ accessory.accessory.ean }}</td>

                    <!-- Name -->
                    <td class="text-left">
                      <h6>{{ accessory.accessory.label }}</h6>
                    </td>

                    <!-- Remise -->
                    <td></td>

                    <!-- TVA -->
                    <td>
                      @if (orderLoad[1] == product.externalId) {
                        <ng-casto-loader></ng-casto-loader>
                      } @else {
                        <div>
                          {{ accessory.tva }}%
                          @if (!isSupplierSent()) {
                            <svg
                              class="icon-action-edit"
                              (click)="updateTvaAccessory(product, accessory)">
                              <use xlink:href="assets/img/icons.svg#icon-action-edit"></use>
                            </svg>
                          }
                        </div>
                      }
                    </td>

                    <!-- Price unit -->
                    <td>
                      @if (orderLoad[1] == product.externalId) {
                        <ng-casto-loader></ng-casto-loader>
                      } @else {
                        <div>
                          {{ getAccessoryUnitPriceTtc(accessory) | number: '1.2-2' : 'fr' }}&nbsp;€
                        </div>
                      }
                    </td>

                    <!-- Quantity -->
                    <td>
                      @if (orderLoad[1] == product.externalId) {
                        <ng-casto-loader></ng-casto-loader>
                      } @else {
                        <div>
                          {{ accessory.quantity }}
                          @if (!isSupplierSent()) {
                            <svg class="icon-action-edit" (click)="updateQuantityAccessory(accessory)">
                              <use xlink:href="assets/img/icons.svg#icon-action-edit"></use>
                            </svg>
                          }
                        </div>
                      }
                    </td>

                    <!-- TTC -->
                    <td class="text-right">
                      @if (orderLoad[1] == product.externalId) {
                        <ng-casto-loader></ng-casto-loader>
                      } @else {
                        <div>
                          {{ getAccessoryTotalPriceTtc(accessory) | number: '1.2-2' : 'fr' }}&nbsp;€
                        </div>
                      }
                    </td>

                    <!-- Observations -->
                    <td></td>

                    <td>
                      @if (!isSupplierSent()) {
                        <button
                          (click)="deleteAccessory(product.externalId, accessory.accessory.id)"
                          class="section-delete-button">
                          <svg>
                            <use
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                              xlink:href="assets/img/icons.svg#icon-action-delete"></use>
                          </svg>
                        </button>
                      }
                    </td>

                    <!-- Supplier sent -->
                    <td></td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </section>
      }

      <!-- Services -->
      @if (selectedAssistances != undefined) {
        <div class="product-category">
          <!-- Titre de la catégorie -->
          <section class="product-category-title">
            <p>{{ 'popins.products_list.assistance.main-title' | translate }}</p>
            <p>{{ totalAssistancePrice() | number: '1.2-2' : 'fr' }} €</p>
          </section>

          <table class="table product-table-cart">
            <thead>
              <tr>
                <th>{{ 'popins.products_list.main.columns.type' | translate }}</th>
                <th>{{ 'popins.products_list.main.columns.comment' | translate }}</th>
                <th>{{ 'popins.products_list.main.columns.tva' | translate }}</th>
                <th>{{ 'popins.products_list.main.columns.totalTtc' | translate }}</th>
                <th class="large-column">{{ 'popins.products_list.main.columns.actions' | translate }}</th>
              </tr>
            </thead>

            <tbody>
              @for (assistance of selectedAssistances; track assistance.assistanceType.id) {
                <tr>
                  <!-- Type -->
                  <td>
                    <h6>{{ assistance.assistanceType.label }}</h6>
                  </td>

                  <!-- Comment -->
                  <td>{{ assistance.comment }}</td>

                  <!-- TVA -->
                  <td>{{ assistance.tva }} %</td>

                  <!-- TTC -->
                  <td>{{ assistance.priceTtc | number: '1.2-2' : 'fr' }} €</td>

                  <!-- Actions -->
                  <td>
                    <div class="button-container center">
                      <a class="add-button" (click)="editAssistance(assistance)" [ngClass]="{ disabled: isSupplierSent() }">
                        {{ 'popins.products_list.main.buttons.edit' | translate }}
                      </a>

                      @if (!isSupplierSent()) {
                        <button
                          (click)="deleteAssistance(assistance.assistanceType.id, $event)"
                          class="section-delete-button">
                          <svg>
                            <use
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                              xlink:href="assets/img/icons.svg#icon-action-delete"></use>
                          </svg>
                        </button>
                      }
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>

    <div class="summary-container prices-container shadow">
      @if (orderLoad[1] != -1) {
        <ng-casto-loader></ng-casto-loader>
      } @else {
        <div>
          <div class="price-row">
            <h4 class="title summary-title">{{ 'popins.products_list.aside.totalHT' | translate }} :</h4>
            @if (!shoppingCartProductList.totalPriceDiscountHt) {
              <p class="info">
                {{ shoppingCartProductList.totalPriceHt | number: '1.2-2' : 'fr' }} €
              </p>
            }
            @if (shoppingCartProductList.totalPriceDiscountHt) {
              <span class="info">
                <p>
                  <s>
                    <i>{{ shoppingCartProductList.totalPriceHt | number: '1.2-2' : 'fr' }} €</i>
                  </s>
                </p>

                <p>{{ shoppingCartProductList.totalPriceDiscountHt | number: '1.2-2' : 'fr' }} €</p>
              </span>
            }
          </div>

          <div class="price-row">
            <h4 class="title summary-title">{{ 'popins.products_list.aside.tvaValue' | translate }} :</h4>
            @if (!shoppingCartProductList.tvaDiscount) {
              <p class="info">
                {{ shoppingCartProductList.tva | number: '1.2-2' : 'fr' }} €
              </p>
            }
            @if (shoppingCartProductList.tvaDiscount) {
              <span class="info">
                <p>
                  <s>
                    <i>{{ shoppingCartProductList.tva | number: '1.2-2' : 'fr' }} €</i>
                  </s>
                </p>

                <p>{{ shoppingCartProductList.tvaDiscount | number: '1.2-2' : 'fr' }} €</p>
              </span>
            }
          </div>

          <div class="price-row principale">
            <h4 class="title summary-title">{{ 'popins.products_list.aside.totalTTC' | translate }} :</h4>
            @if (!shoppingCartProductList.totalPriceDiscountTtc) {
              <p class="info">
                {{ shoppingCartProductList.totalPriceTtc | number: '1.2-2' : 'fr' }} €
              </p>
            }
            @if (shoppingCartProductList.totalPriceDiscountTtc) {
              <span class="info">
                <p>
                  <s>
                    <i>{{ shoppingCartProductList.totalPriceTtc | number: '1.2-2' : 'fr' }} €</i>
                  </s>
                </p>

                <p>{{ shoppingCartProductList.totalPriceDiscountTtc | number: '1.2-2' : 'fr' }} €</p>
              </span>
            }
          </div>

          @if (this.shoppingCartProductList.ecoTax > 0) {
            <div class="price-row">
              <h1 class="title summary-title">{{ 'popins.products_list.aside.totalEcotax' | translate }} :</h1>
              <p class="info">{{ this.shoppingCartProductList.ecoTax | number: '1.2-2' : 'fr' }} €</p>
            </div>
          }
        </div>
      }
    </div>
  </div>
}
